import React, { Fragment } from 'react';
import classNames from 'classnames'
import { Outlet } from 'react-router-dom';

export default function MainLayout() {


    const Classes = classNames({
        "fixed h-[100svh] w-screen overflow-x-auto": true
    })

    return (
        <Fragment>
            <main className={Classes}>
                <Outlet />
            </main>
        </Fragment>
    )
}
